import React, { useState } from "react";
import { Route, Switch } from "react-router-dom";
import Menu from '../containers/menuRoleContainer';
import ShowContainer from "../../MenuUser/containers/showContainer";
import { Nav, NavItem, NavLink } from "reactstrap";

function RouterMenuRole() {
    const [activeTab, setActiveTab] = useState("1");

  function handleChangeTabPanel(tabValue) {
    if (activeTab !== tabValue) {
      setActiveTab(tabValue);
    }
  }

    return (
        <div>
            <Route path="/">
                <Switch>
                    <Route path="/MenuRole" exact>
                        <div className="header-bodyui">
                            <b className="ml-3" style={{ fontSize: 20 }}>Phân Quyền</b>
                            <div className="row buttonadd">
                                <div className="col-md-2">
                                    {/* <Button
                                        variant="contained"
                                        color="secondary"
                                        className={"add-new-button btn"}
                                        startIcon={<AddCircle />}
                                        onClick={Newbutton}
                                    >
                                        New
                                    </Button> */}
                                </div>
                            </div>
                        </div>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                     className={`nav-link-tab${activeTab === "1"
                                     ? " active active-customize-tab"
                                     : " unactive-tab"
                                   }`}
                                    onClick={() => handleChangeTabPanel("1")}
                                >
                                    Menu User
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                     className={`nav-link-tab${activeTab === "2"
                                     ? " active active-customize-tab"
                                     : " unactive-tab"
                                   }`}
                                    onClick={() => handleChangeTabPanel("2")}
                                >
                                    Menu Role
                                </NavLink>
                            </NavItem>
                        </Nav>
                        {activeTab === '1' && ( <ShowContainer />)}
                        {activeTab === '2' && ( <Menu />)}
                    </Route>
                </Switch>
            </Route>
        </div>
    );
}

export default RouterMenuRole;